import * as R from "ramda";
import cx from "classnames";
import { arrayOf } from "prop-types";
import { eventId, eventShape } from "../event.js";
import AnimateHeight from "react-animate-height";

const propTypes = {
  events: arrayOf(eventShape).isRequired,
};

// the number of visible events
const getVisibleEventCount = (events) =>
  R.compose(R.length, R.filter(R.propEq("isVisible", true)))(events);

const EventList = (props) => {
  const { events } = props;

  const eventsByYear = R.compose(
    R.sortBy(R.prop("year")),
    R.map((pair) => {
      const [year, events] = pair;
      return { year, events };
    }),
    R.toPairs,
    R.groupBy(R.prop("year")),
  )(events);

  const firstVisibleYear = R.compose(
    R.prop("year"),
    R.defaultTo({}),
    R.find((group) => getVisibleEventCount(group.events) !== 0),
  )(eventsByYear);

  const firstVisibleEventId = R.compose(
    eventId,
    R.find(R.propEq("isVisible", true)),
    R.sortBy(R.prop("year")),
  )(events);

  const lastVisibleEventId = R.compose(
    eventId,
    R.findLast(R.propEq("isVisible", true)),
    R.sortBy(R.prop("year")),
  )(events);

  const DURATION = 250;

  return (
    <div className="event-list">
      {eventsByYear.map((group) => {
        const { year, events } = group;

        const eventCount = getVisibleEventCount(events);

        return (
          <div className="event-list__year-group" key={year}>
            <AnimateHeight
              duration={DURATION}
              height={eventCount === 0 ? 0 : "auto"}
            >
              <div
                className={cx("event-list__year", {
                  "event-list__year--is-first": year === firstVisibleYear,
                })}
              >
                {year}
              </div>
            </AnimateHeight>
            {events.map((event) => {
              return (
                <AnimateHeight
                  key={eventId(event)}
                  duration={DURATION}
                  height={event.isVisible ? "auto" : 0}
                >
                  <div
                    className={cx("event-list__event", {
                      "event-list__event--is-first":
                        firstVisibleEventId === eventId(event),
                      "event-list__event--is-last":
                        lastVisibleEventId === eventId(event),
                    })}
                    id={eventId(event)}
                  >
                    <div className="event-list__event-title">
                      <div
                        className="event-list__dot"
                        style={{ backgroundColor: event.color }}
                      />
                      <div dangerouslySetInnerHTML={{ __html: event.title }} />
                    </div>
                    <div
                      className="event-list__event-description"
                      dangerouslySetInnerHTML={{ __html: event.description }}
                    />
                  </div>
                </AnimateHeight>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

EventList.propTypes = propTypes;
export default EventList;
